var map = {
	"./google-laurel-da-DK.svg": 43208,
	"./google-laurel-de-DE.svg": 16298,
	"./google-laurel-en-GB.svg": 12648,
	"./google-laurel-en-US.svg": 50499,
	"./google-laurel-es-ES.svg": 72788,
	"./google-laurel-es-MX.svg": 76311,
	"./google-laurel-fr-FR.svg": 6172,
	"./google-laurel-it-IT.svg": 92754,
	"./google-laurel-nb-NO.svg": 72705,
	"./google-laurel-nl-NL.svg": 16696,
	"./google-laurel-pl-PL.svg": 56752,
	"./google-laurel-pt-BR.svg": 988,
	"./google-laurel-pt-PT.svg": 55392,
	"./google-laurel-sv-SE.svg": 29761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;